<template>
  <div class="language-selector">    
    <!-- 左侧三角形指针 -->
    <div class="triangle-pointer"></div>
    
    <div class="lang-dropdown">
      <div 
        v-for="(lang, index) in languages" 
        :key="lang.code" 
        class="lang-option"
        @click="selectLanguage(lang)"
        @mouseenter="focusedIndex = index"
      >
        <div class="lang-icon">{{ lang.icon }}</div>
        <span class="lang-name">{{ lang.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelector',
  props: {
    // 支持的语言列表
    languages: {
      type: Array,
      required: true,
      default: () => []
    },
    // 当前选中的语言
    currentLanguage: {
      type: Object,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    // 选择语言并通知父组件
    selectLanguage(lang) {
      this.$emit('language-changed', lang);
    },
  },
  mounted() {
    
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>
.language-selector {
  width: 144px;
  height: 92px;
  padding-left: 10px;
  position: absolute;
  display: flex;
  align-items: center;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  top: -20px;
  left: 70px;
  z-index: 1;
  transform-origin: bottom left;
  animation: expand 0.6s ease-out forwards;
  cursor: pointer;
}

.triangle-pointer {
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #fff;
  margin-right: -1px;
  z-index: 2;
}

.lang-dropdown {
  width: 115px;
  height: 90px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@keyframes expand {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.lang-dropdown {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.lang-option {
  cursor: pointer;
  width: 120px;
  height: 37px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  font-size: 15px;
  /* color: rgba(33, 33, 33, 1); */
  color: rgba(117, 117, 117, 1);

}

.lang-option:hover {
  background: rgba(235, 235, 235, 1);
  color: rgba(33, 33, 33, 1);
}

.lang-icon{
  width: 20px;
  height: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  margin-left: 5px;
}

.lang-name{
  margin-left: 8px;
}

.fa-chevron-down {
  transition: transform 0.2s;
  font-size: 12px;
}

.fa-chevron-down.open {
  transform: rotate(180deg);
}
</style>